import Icon from '@ant-design/icons';

const TriangleSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Size=16, Name=Estimate">
        <path
          id="Vector 64 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.09578 3.14246C8.31038 3.14246 8.50765 3.26028 8.60939 3.44923L12.9027 11.4226C13.0001 11.6033 12.9952 11.822 12.8899 11.9982C12.7846 12.1745 12.5944 12.2825 12.3891 12.2825H3.80245C3.59713 12.2825 3.40693 12.1745 3.30165 11.9982C3.19636 11.822 3.1915 11.6033 3.28884 11.4226L7.58218 3.44923C7.68392 3.26028 7.88119 3.14246 8.09578 3.14246ZM4.77908 11.1158H11.4125L8.09578 4.95619L4.77908 11.1158Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const TriangleIcon = (props: any) => <Icon component={TriangleSvg} {...props} />;
